import React, { useState, useContext, useEffect, useLayoutEffect } from 'react'
import { Context } from './Context'
import axios from 'axios'
import { QuoteData } from '../wbstdt/Wbstdt'
import Nav from './Nav'
import Footer from './Footer'
import MessageDelivery from './MessageDelivery'
import LoadingScreen from './LoadingScreen'

export default function Quote() {

    const { lang } = useContext(Context)
    const [code, setCode] = useState(QuoteData[lang].tab4[0].code)
    const [country, setCountry] = useState(QuoteData[lang].tab4[0].country)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [address, setAddress] = useState('')
    const [city, setCity] = useState('')
    const [number, setNumber] = useState('')
    const [company, setCompany] = useState('')
    const [position, setPosition] = useState('')
    const [message, setMessage] = useState('')
    const [isFormEmpty, setIsFormEmpty] = useState(true)
    const [msgDlShown, setMsgDlShown] = useState("")
    const [isLoading, setIsloading] = useState(false)

    useEffect(() => {

        if (!name || !email || !address || !city || !number || !company || !position)
            setIsFormEmpty(true)
        else
            setIsFormEmpty(false)

    }, [name, email, address, city, number, company, position])


    useLayoutEffect(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }, [])

    const setRegion = (e) => {
        let countryCode = QuoteData[lang].tab4.filter(item => item.country === e.target.value)
        setCountry(countryCode[0].country)
        setCode(countryCode[0].code)
    }

    const sendEmail = (e) => {
        e.preventDefault()
        let messageBody = {
            name,
            email,
            country,
            number: `${code} ${number}`,
            address,
            city,
            company,
            position,
            message
        }
        setIsloading(true)
        axios.post('/sending-quote', {messageBody})
        .then(data => {
            setIsloading(false)
            setName("")
            setEmail("")
            setNumber("")
            setAddress("")
            setCity("")
            setCompany("")
            setPosition("")
            setMessage("")
            setMsgDlShown("ss")
            setTimeout(() => {
                setMsgDlShown("")
            }, 3000);
        })
        .catch(err => {
            setIsloading(false)
            setMsgDlShown("ss")
            setTimeout(() => {
                setMsgDlShown("fl")
            }, 3000);
            console.log(err)
        })
    }

    return (
        <div id="quote-page">
            {isLoading && <LoadingScreen />}
            <Nav />
            <div className="cp-container box-wsp-outline">
                <div className="flex-container-centered">
                    <h2 className="title title-bullet">{QuoteData[lang].title}</h2>
                </div>
                <div className="container flex-container-centered">
                    <p>{QuoteData[lang].desc}</p>
                </div>
                <div className="form box-wsp">
                    <form className="container flex-container-scattered" onSubmit={sendEmail}>
                        <input type="text" className="if ifs-small" placeholder={QuoteData[lang].tab1} value={name} onChange={(e) => setName(e.target.value)} required/>
                        <input type="email" className="if ifs-small" placeholder={QuoteData[lang].tab2} value={email} onChange={(e) => setEmail(e.target.value)} required/>
                        <input type="text" className="if ifs-small" placeholder={QuoteData[lang].tab3} value={address} onChange={(e) => setAddress(e.target.value)} required/>
                        <input type="text" className="if ifs-small" placeholder={QuoteData[lang].tab5} value={city} onChange={(e) => setCity(e.target.value)} required/>
                        <select className="if ifs-small" value={country} onChange={setRegion}>
                            {QuoteData[lang].tab4.map((item, index) => {
                                return (
                                    <option key={index} value={item.country}>{item.country}</option>
                                )
                            })}
                        </select>
                        <div className="tel-if tel-ifs-small">
                            <label htmlFor="tel">{code}</label>
                            <input type="tel" className="ifs-full" name="" id="tel" placeholder={QuoteData[lang].tab6} value={number} onChange={(e) => setNumber(e.target.value)} pattern="^[+]*[0-9]{8,15}$" required/>
                        </div>
                        <input type="text" className="if ifs-small" placeholder={QuoteData[lang].tab7} value={company} onChange={(e) => setCompany(e.target.value)} required/>
                        <input type="text" className="if ifs-small" placeholder={QuoteData[lang].tab8} value={position} onChange={(e) => setPosition(e.target.value)} required/>
                        <textarea type="text" className="if ifs-full txt-area" placeholder={QuoteData[lang].tab9} value={message} onChange={(e) => setMessage(e.target.value)} />
                        <button className={`btn btn-full ${!isFormEmpty ? "btn-normal-enabled" : "btn-normal-disabled"}`} disabled={isFormEmpty}>{QuoteData[lang].btn}</button>
                    </form>
                </div>
            </div>
            <Footer />
            {msgDlShown && <MessageDelivery msg={msgDlShown}/>}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Component/Quote.js